export default "__VITE_ASSET__1tns94f2__"